import { useEffect } from 'react';
import { computeAppBadge } from '../utils/badge';
import type { BootstrapData } from '../api/types';

type BadgeNavigator = Navigator & {
  setAppBadge?: (n?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

function setBadge(n: number): void {
  const nav = navigator as BadgeNavigator;
  if (typeof nav.setAppBadge !== 'function') return; // нет API (PWA не установлена) → no-op
  const p = n > 0 ? nav.setAppBadge(n) : (nav.clearAppBadge?.() ?? nav.setAppBadge(0));
  void p.catch(() => {});
}

/** Пересчёт при каждом изменении viewData + при уходе в фон (спека §5). */
export function useAppBadge(viewData: BootstrapData | null): void {
  useEffect(() => {
    setBadge(viewData ? computeAppBadge(viewData) : 0);
  }, [viewData]);

  useEffect(() => {
    function onHide() {
      if (document.hidden) setBadge(viewData ? computeAppBadge(viewData) : 0);
    }
    document.addEventListener('visibilitychange', onHide);
    return () => document.removeEventListener('visibilitychange', onHide);
  }, [viewData]);
}
